import React, { useEffect, useState } from 'react';

const Banner = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        // Function to determine the correct image URL based on screen size
        const updateImage = () => {
            if (window.matchMedia("(max-width: 767px)").matches) {
                // Mobile view
                // setImageUrl(process.env.PUBLIC_URL + '/assets/image/client-mobile.png');
                setImageUrl(process.env.PUBLIC_URL + '/assets/image/client-mobile.webp');
            } else {
                // Desktop view
                setImageUrl(process.env.PUBLIC_URL + '/assets/image/client-desktop-new.webp');
            }
        };

        // Initial image selection
        updateImage();

        // Add a listener to update the image when the screen size changes
        window.addEventListener('resize', updateImage);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateImage);
        };
    }, []);

    useEffect(() => {
        if (imageUrl) {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
                setTimeout(() => {
                    setIsLoaded(true);
                }, 300);
            };
        }
    }, [imageUrl]);

    return (
        <section className="banner-section mobile-banner-section">
            {imageUrl && <img src={imageUrl} className="banner-background-image" alt="Banner Background" />}
            <div className="container h-100 time-delay banner-content-top">
                <div className="row">
                    <div className="col-lg-12">
                        <div className={`banner-content ${isLoaded ? 'loaded' : ''}`}>
                            <div className="banner-heading">
                                <h1>Inspirons <br /> les gens</h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className={`banner-content ${isLoaded ? 'loaded' : ''}`}>
                            <div className="banner-heading banner-heading-bottom">
                                <h1>à créer <br />de la <span>valeur</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
